import Tool, { type ToolArgs } from '../../../tools/Tool';
import { isSelectionInList, inListOfType } from '../utils';
import ListDepthUtils from '../ListDepthUtils';

// Unindent a list item.
class ToolDecreaseIndent extends Tool {
  static toolName = 'Decrease indent';
  static iconClass = 'fa-regular fa-outdent';

  static action({ editor }: ToolArgs): void {
    ListDepthUtils.decreaseDepth(editor);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    return isSelectionInList(editor) && !inListOfType(editor, 'dl_list');
  }
}

export default ToolDecreaseIndent;
